import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';

import { roles } from 'utility/constants/roles';
import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';

const Feedback = lazy(() => import('pages/feedback/Feedback'));

const FeedbackRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				whitelistedRoles={[
					roles.PURCHASER,
					roles.TECHNICIAN,
					roles.SUSPENDED_OWNER,
				]}
				path="/feedback"
				component={Feedback}
			/>
		</Switch>
	);
};

export default FeedbackRouter;
